import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import { REDUCER_NAME, SET_ERROR, SET_SOCIALLINKS } from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  socialLinks: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SOCIALLINKS:
      return {
        ...state,
        isReady: true,
        isError: false,
        socialLinks: action.data,
      };
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectSocialLinks = createSelector(getState, (n) => n.socialLinks);

reducerRegistry.register(REDUCER_NAME, reducer);
